import { useMutation, useQuery, useQueryClient } from "react-query";
import React from "react";
import * as wf from "@qpr/client-api-workflow";
import createUICardElement from "backend/utils/createUICardElement";

const useWorkflowInstance = (id?: string) => {
  return useQuery(
    JSON.stringify(["workflow-instance", id]),
    () => {
      return wf
        .getInstance(id || "")
        .then((data) =>
          createUICardElement(data.wfInstanceId, "workflowinstance", data)
        );
    },
    {
      enabled: !!id,
      cacheTime: 1 * 1000,
    }
  );
};

export default useWorkflowInstance;
